export enum LogoTypeEnum {
  Footer = 'logo_footer',
  Light = 'logo_light',
  OrganizerDark = 'logo_organizer_dark',
  OrganizerLight = 'logo_organizer_light',
  Regular = 'logo_regular',
}
